import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import PrimaryFilterFormSkeleton from 'search/filters/base/PrimaryFilterFormSkeleton';
import {FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';
import {ButtonSize} from 'ui-library/buttons/Button';

export interface AuditLogFilterDropdownProps {
  label: string;
  count: number;
  content: JSX.Element;
  disabled?: boolean;
}

export default function AuditLogFilterDropdown({
  label,
  count,
  content,
  disabled = false,
}: AuditLogFilterDropdownProps): JSX.Element {
  const dropdownToggleText = (
    <span className={css(styles.label)}>
      {label}
      {count > 0 && <span className={css(styles.countBadge)}>{count}</span>}
    </span>
  );

  return (
    <div>
      <PrimaryFilterFormSkeleton
        buttonSize={ButtonSize.SMALL}
        dropdownToggleText={dropdownToggleText}
        content={content}
        closeOnInsideClick={false}
        isActive={count > 0}
        isDisabled={disabled}
        tooltipTitle={null}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  label: {
    alignItems: 'center',
  },
  countBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 10,
    backgroundColor: Color.BLUE_500,
    color: Color.WHITE,
    fontSize: 12,
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
    marginLeft: 6,
    padding: '2px 6px',
    minWidth: 20,
  },
});
